import React, { useState } from 'react';
import { useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import { CountryVisited } from '@marageti/z4-sdk/lib/people';
import TravelerProfileCountriesView from './traveler-profile-countries-view';
import TravelerProfileCountriesModal from './traveler-profile-countries-modal';
import useTravelerProfile from '../../hooks/use-traveler-profile';

export type TravelerProfileCountriesContainerProps = {
  travelerId: string | undefined;
  canEdit: boolean;
};

const TravelerProfileCountriesContainer = ({
  travelerId,
  canEdit,
}: TravelerProfileCountriesContainerProps) => {
  const apiClient = useApiClient();
  const { travelerProfile, updateTravelerProfile } = useTravelerProfile(travelerId);
  const { data: countryCodes } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);

  const countries = travelerProfile?.countriesVisited ?? [];
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleSave = async (codes: CountryVisited[]) => {
    await updateTravelerProfile(
      { countriesVisited: codes },
      'Could not save countries visited.',
      'Countries visited saved',
    );
  };

  return (
    <>
      <TravelerProfileCountriesView
        countriesVisited={countries}
        countryCodes={countryCodes}
        onEdit={canEdit ? handleOpenModal : undefined}
      />
      <TravelerProfileCountriesModal
        initialCountries={countries}
        countryCodes={countryCodes}
        onClose={handleCloseModal}
        onSubmit={handleSave}
        open={isModalOpen}
      />
    </>
  );
};

export default TravelerProfileCountriesContainer;
